export default __webpack_public_path__ + "static/Innovative software consulting_logo-3e79721174857f9f4ae4c4c58432c801.png";